/* ============================================================================
   PageHeader — título + subtítulo + ação opcional à direita.
   ============================================================================ */
export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="mg-page-head">
      <div className="mg-page-head-left">
        <h1 className="mg-page-title">{title}</h1>
        {subtitle && <p className="mg-page-sub">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
